export default __webpack_public_path__ + "static/media/share.00e4c402.svg";